<template>
  <section class="tu-construye-progress" aria-labelledby="tu-construye-progress-title">
    <picture class="tu-construye-progress__media">
      <img
        :src="obraImage"
        alt="Trabajadores revisando los planos de una obra"
        class="tu-construye-progress__image"
      >
    </picture>

    <div class="tu-construye-progress__content">
      <DsChip label="Tu obra" variant="orange" />

      <h2 id="tu-construye-progress-title" class="tu-construye-progress__title">
        Así es como medimos tu obra
      </h2>

      <div class="tu-construye-progress__items">
        <DsPercentItem
          v-for="stage in stages"
          :key="stage.id"
          :value="stage.value"
          :title="stage.title"
          :description="stage.description"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import obraImage from '../../../assets/tu-construye/obra.jpg'
import DsChip from '../atoms/DsChip.vue'
import DsPercentItem from '../atoms/DsPercentItem.vue'

const stages = [
  {
    id: 'foundation',
    value: '30%',
    title: 'Cimentación',
    description: 'Nivelación, excavación, drenaje y estructura de base.'
  },
  {
    id: 'structure',
    value: '30%',
    title: 'Estructura y Techado',
    description: 'Muros, losa, castillos y columnas.'
  },
  {
    id: 'finishes',
    value: '25%',
    title: 'Acabados',
    description: 'Pisos, aplanados, instalaciones eléctricas/hidráulicas, ventanas y puertas.'
  },
  {
    id: 'completion',
    value: '15%',
    title: 'Terminación',
    description: 'Pintura, azulejos, muebles de baño y cocina.'
  }
]
</script>

<style scoped>
.tu-construye-progress {
  display: flex;
  align-items: center;
  gap: 24px;
}

.tu-construye-progress__media {
  display: block;
  flex-shrink: 0;
  width: 370px;
  align-self: stretch;
  border-radius: 24px;
  overflow: hidden;
}

.tu-construye-progress__image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tu-construye-progress__content {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  min-width: 0;
}

.tu-construye-progress__title {
  margin: 0;
  font-family: var(--ds-font-family-bebas);
  font-size: var(--ds-bebas4-size);
  font-weight: 700;
  color: var(--ds-purple-900);
}

.tu-construye-progress__items {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
}

/* En tablet el Figma conserva las dos columnas, con la imagen más estrecha. */
@media (max-width: 1024px) {
  .tu-construye-progress__media {
    width: 272px;
  }
}

@media (max-width: 743px) {
  .tu-construye-progress {
    flex-direction: column;
    align-items: stretch;
  }

  .tu-construye-progress__media {
    width: 100%;
    height: 280px;
  }
}
</style>
